<template>
  <div class="icon-link-slider" style="z-index: 0">
    <loading :active.sync="isLoading" :is-full-page="false" style="z-index: 0"></loading>
    <swiper :options="swiperOption" style="height: 200px; margin-top: 10px; width: 100%">
      <swiper-slide class="block" v-for="(s, index) in iconLinks"
                    :key="'icon' + index">
        <div class="nav-icon-img">
          <a v-bind:href="s.tb_url" target="_blank">
            <img :src="s.tb_pic" width="60px" height="60px" style="border-radius: 10px;"/>
          </a>
        </div>
        <div class="nav-title">{{ s.tb_name }}</div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
export default {
  name: 'IconLinkSlider',
  props: {
    circleBackground: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isLoading: true,
    swiperOption: {
      slidesPerView: 8,
      slidesPerColumn: 2,
      spaceBetween: 30,
    },
    iconLinks: [{
        tc_pic: '../../images/placholder_1200.svg',
        tc_name: '',
        tc_url: ''
      },
        {
          tc_pic: '../../images/placholder_1200.svg',
          tc_name: '',
          tc_url: ''
        }],
  }),
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      axios.get('/ticket/api/brand/recommend/list')
          .then((response) => {
            this.iconLinks = response.data;
            this.isLoading = false;
          })
    },
  }
}
</script>

<style lang="scss" scoped>
@mixin i5 {
  @media (max-width: 340px) {
    @content;
  }
}

.swiper-slide {
  //text-align: center !important;

  height: 67px !important;
  width: 60px !important;
  margin-right: 10px !important;
  margin: auto !important;
  text-align: center !important;
}

.swiper-container {
  margin-top: 20px !important;
}

.icon-link-slider {
  .nav-title {
    font-size: 11px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 62px;
    margin: 0 auto;
    font-weight: 500;
  }
}
</style>
